import { endpoints } from '../../endpoints';
import { validateResponseData } from '../../utils';
import axiosInstance from '../../utils/axiosInstance';
import {
  acceptOfferResponseSchema,
  signOfferResponseSchema,
  withdrawalStatusResponseSchema
} from './schemas';

export const signOffer = async (applicationId: string) => {
  const response = await axiosInstance.post(
    endpoints.SE.loan.applications.applicationId(applicationId).signOffer
  );

  return validateResponseData(signOfferResponseSchema, response.data);
};

export const acceptOffer = async (applicationId: string) => {
  const response = await axiosInstance.post(
    endpoints.SE.loan.applications.applicationId(applicationId).acceptOffer
  );

  return validateResponseData(acceptOfferResponseSchema, response.data);
};

export const getWithdrawalStatus = async () => {
  const response = await axiosInstance.get(endpoints.SE.loan.withdrawalStatus);

  return validateResponseData(withdrawalStatusResponseSchema, response.data);
};
